import { useWallet } from "@sundae/wallet-react";
import { useMemo } from "react";
export const useIsWalletConnected = () => {
    const { state: { activeWallet }, } = useWallet();
    return useMemo(() => Boolean(activeWallet), [activeWallet]);
};
//# sourceMappingURL=useIsWalletConnected.js.map